import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useAuthState } from '../../../../Helper/Context/context';
// import { DefineProjectPostAPI } from '../../../../Helper/Redux/MasterSlice/DefineProjectSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RegExOnlyText } from '../../../../Helper/regEx/RegExOnlyText';
import { DefineProjectPostAPI } from '../../../../Helper/Redux/MasterSlice/DefineProjectSlice';
import { AstricSign } from '../../../../Helper/AstricSign';

export default function AddProjectPopUp(props) {

    const { handleShowAddModal, handleIsPost, ShowAddModal } = props
    const { flag, data } = ShowAddModal

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    const [ProjectCode, setProjectCode] = useState()
    const [ProjectName, setProjectName] = useState(flag == 'Update' ? data.projectName : '')

    const [IsValidText, setIsValidText] = useState(false)

    const handleCheckText = (e) => {
        setProjectName(e.target.value)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }

    const handleSubmit = () => {
        const data = {

            M_ProjectID: flag == 'Update' ? ShowAddModal.data.m_ProjectID : 0,
            ProjectName: ProjectName,
            ProjectCode: '',
            M_TableUserMasterID: UserID,
            Flag: flag,
            token: token,
            handleIsPost
        }
        dispatch(DefineProjectPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.DefineProjectPostData)

    const handleClear = () => {
        setProjectName('')
    }

    const handleClearCancel = () => {
        flag == 'Update' ? handleShowAddModal(false, '') : handleClear()
        console.log("flag", flag)
    }

    return (
        <>
            <div className="modal fade show" style={{ display: "block", backgroundColor: "#00000055" }}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header ml-4">
                            <h5 className="modal-title" id="exampleModalLongTitle">Define Project</h5>
                            <button onClick={() => handleShowAddModal(false, '')} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body mx-4">


                            <div className="row">

                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label>Project Name <AstricSign/></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DepartmentName"
                                            placeholder="Project Name"
                                            value={ProjectName}
                                            onChange={(e) => handleCheckText(e)}

                                        />
                                        {
                                            IsValidText && <text style={{ color: 'red' }}>Please enter Alphabets characters only</text>
                                        }

                                    </div>
                                </div>
                                {/* <div className=" col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label>Project Code<span className='text-danger'></span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="ProjectCode"
                                            placeholder="Project Code"
                                            value={ProjectCode}
                                            onChange={(e) => setProjectCode(e.target.value)}

                                        />

                                    </div>
                                </div> */}


                                <div className="col-12">
                                    <div className="form-group float-end mt-lg-3">

                                        <button type="button" className="btn btn-outline-dark border-2 mx-2"
                                            disabled={ProjectName == ""}
                                            onClick={handleSubmit}> {flag == 'Update' ? "Update" : "Add"}</button>

                                        <button type="button" className="btn btn-danger border-2"
                                            onClick={handleClearCancel}>
                                            {flag == 'Update' ? "Cancel" : "Clear"}
                                        </button>



                                    </div>
                                </div>

                            </div>




                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}